module.exports = __webpack_public_path__ + "static/media/HeartsLoader@2X.ee7c2c9d.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/loader/HeartsLoader@2X.gif
// module id = 3869
// module chunks = 70